export default __webpack_public_path__ + "static/media/easypaisa.ce2720f1.svg";